import { makeStyles } from "@material-ui/styles";

export default makeStyles(({ breakpoints }) => ({
  gridItem: {
    [breakpoints.down("xs")]: {
      flexGrow: 1
    }
  }
}));
